






import { Component, Vue, Provide, Prop } from 'vue-property-decorator'

@Component
export default class LoadingComponent extends Vue{

  @Provide() overlay: boolean = false
  @Provide() inheritAttrs: boolean = true
  @Provide() defaultProps: any = {
        spinnerProps: {
          color: "primary",
          value: 100,
          indeterminate: true,
          size: 50
        }
      }
  @Provide() options: any = {
    spinnerProps: {}
  }
  @Prop({
    type: Object,
    required: true
  }) spinnerProps !: Object

    show() {
      this.overlay = true
    }

    hide() {
      this.overlay = false
    }

    mergeProps() {
      //merge snipper props
      this.options.spinnerProps = {
        ...this.defaultProps.spinnerProps,
        ...this.$props.spinnerProps
      }
    }
  
  beforeMount() {
      this.$nextTick(function() {
        let app: any = document.getElementById("appRoot")
        app.appendChild(this.$el)
      })
  }

  mounted() {
    this.mergeProps()
  }
}
